<ng-container *ngIf="_checklists[0]?.displayMethod === 'form' else tabs_template">
  <ng-container *ngFor="let list of _checklists; let listIndex = index">
    <ng-container *ngFor="let row of list.rows; let rowIndex = index">
      <app-project-info-checklist-section
        [rowIndex]="rowIndex"
        [checklistIndex]="listIndex"
        [checklistColumnsInput]="list.columns"
        [checklistRowInput]="row"
        [sectionTitle]="sectionTitles[listIndex][rowIndex]"
        [isFirstFeedstockSection]="sectionIsFirstFeedstock[listIndex][rowIndex]"
        [(editInProgress)]="editInProgress"
        (addSectionNotifier)="addSection(listIndex, rowIndex, $event)"
        (removeSectionNotifier)="removeSection(listIndex, rowIndex, $event)"
        (saveSectionNotifier)="saveSection(listIndex, rowIndex, $event)">
      </app-project-info-checklist-section>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #tabs_template>
  <ng-container *ngIf="_checklists[0]?.displayMethod === 'tabs'">
    <mat-tab-group #tabGroup [animationDuration]="0" mat-align-tabs="center">
      <ng-container *ngFor="let list of _checklists; let listIndex = index">
        <ng-container *ngFor="let row of list.rows; let rowIndex = index">
          <mat-tab [label]="sectionTitles[listIndex][rowIndex]">
            <ng-template matTabContent>
              <app-project-info-checklist-section
                [rowIndex]="rowIndex"
                [checklistIndex]="listIndex"
                [checklistColumnsInput]="list.columns"
                [checklistRowInput]="row"
                [sectionTitle]="sectionTitles[listIndex][rowIndex]"
                [isFirstFeedstockSection]="sectionIsFirstFeedstock[listIndex][rowIndex]"
                [isTabStyle]="true"
                [(editInProgress)]="editInProgress"
                (addSectionNotifier)="addSection(listIndex, rowIndex, $event)"
                (removeSectionNotifier)="removeSection(listIndex, rowIndex, $event)"
                (saveSectionNotifier)="saveSection(listIndex, rowIndex, $event)"
                (cancelNotifier)="editCancel(listIndex, rowIndex, $event)">
              </app-project-info-checklist-section>
            </ng-template>
          </mat-tab>
        </ng-container>
      </ng-container>
    </mat-tab-group>
  </ng-container>
</ng-template>